import React from "react";
import Modal from "react-bootstrap/Modal";

const Header = ({ isEditMode = false }) => {
    return (
        <Modal.Header>
            <Modal.Title>
                {isEditMode ? "Edit Auth Service" : "Create New Auth Service"}
            </Modal.Title>
        </Modal.Header>
    );
};

export default Header;
